import moment from "moment";

export const getFilterDateRange = (filter: number, step = 0) => {
  const now = moment();
  let startDate;
  let endDate;

  switch (filter) {
    case 1:
      startDate = now.clone().add(step, "months").startOf("month");
      endDate = now.clone().add(step, "months").endOf("month");
      break;
    case 2:
      startDate = now.clone().add(step, "weeks").startOf("week");
      endDate = now.clone().add(step, "weeks").endOf("week");
      break;
    case 3: {
      const currentWeekStart = moment().startOf("week");
      const targetWeekStart = currentWeekStart.clone().add(step * 7, "days");
      startDate = targetWeekStart.clone();
      endDate = targetWeekStart.clone().add(6, "days");
      break;
    }
    default:
      startDate = now;
      endDate = now;
  }

  return {
    startDate: startDate.format("YYYY-MM-DD"),
    endDate: endDate.format("YYYY-MM-DD"),
  };
};
